import {
	ChatIcon,
	FAQIcon,
	HistoryTimerIcon,
	KeyIcon,
	MarketingConsentsIcon,
	PersonalDataIcon,
	PromoCodeIcon,
	RegulationIcon,
	ResponsilbeGamingIcon,
	RulesIcon,
	SettingsIcon,
	VipChatIcon,
	VipRankIcon,
} from 'assets/icons';
import { History, LocationState } from 'history';
import { t } from 'i18next';
import { FC } from 'react';
import ActionCard from 'shared/components/card-views/actionCard';
import { APP_URL, EXTERNAL_LINKS, SectionNavigation } from 'shared/constants/common';
import { handleRemoveOverflow } from 'shared/util/utility';
import { StarsIcon } from '../../../assets/icons/StarsIcon';
import PlayerProfileDialog from '../cpPlayerProfile/component/PlayerProfileDialog';

interface Props {
	isVip: boolean;
	rangiVipRedirection: () => void;
	changeNavigationView: (view: SectionNavigation, params?: Record<string, string | number>) => void;
	dialogOpen: boolean;
	setDialogOpen: (value: boolean) => void;
	handleClosePanel: () => void;
	history: History<LocationState>;
}

const CpActionCards: FC<Props> = ({ isVip, rangiVipRedirection, changeNavigationView, dialogOpen, setDialogOpen, history }) => {
	return (
		<>
			<div className="user-panel-options">
				{isVip && (
					<div className="action-list">
						<span className="action-list-title">{t('vipUserMenu')}</span>
						<div className="action-list-item" onClick={rangiVipRedirection}>
							<VipRankIcon />
							{t('rangiVip')}
						</div>
						<div className="action-list-item" onClick={() => history.push(APP_URL.chatVip)}>
							<VipChatIcon />
							{t('chatVip')}
						</div>
					</div>
				)}
				<div className="action-list">
					<span className="action-list-title">{t('myAccount')}</span>
					<ActionCard
						data={{
							label: t('generalSettingsPersonalData'),
							value: SectionNavigation.CP_PERSONAL_DATA,
							icon: <PersonalDataIcon />,
						}}
						handleRemoveOverflow={handleRemoveOverflow}
						onAction={changeNavigationView}
						cyTestRef="cp-panel-list"
						isSectionNav={true}
					/>

					{dialogOpen && <PlayerProfileDialog isOpen={dialogOpen} setDialogClose={() => setDialogOpen(false)} />}

					<ActionCard
						data={{
							label: t('changePassword'),
							value: SectionNavigation.CP_CHANGE_PASSWORD,
							icon: <KeyIcon />,
						}}
						handleRemoveOverflow={handleRemoveOverflow}
						onAction={changeNavigationView}
						isSectionNav={true}
					/>

					<ActionCard
						data={{
							label: t('generalSettingsPolicy'),
							value: SectionNavigation.CP_RESPONSIBLE_GAME,
							icon: <ResponsilbeGamingIcon />,
						}}
						handleRemoveOverflow={handleRemoveOverflow}
						onAction={changeNavigationView}
						isSectionNav={true}
					/>

					<ActionCard
						data={{
							label: t('activityHistory'),
							value: SectionNavigation.CP_ACTIVITY_HISTORY,
							icon: <HistoryTimerIcon />,
						}}
						handleRemoveOverflow={handleRemoveOverflow}
						onAction={changeNavigationView}
						isSectionNav={true}
						cyTestRef="cp-panel-list"
					/>

					<ActionCard
						data={{
							label: t('accountSettingsPromotionCode'),
							value: SectionNavigation.CP_PROMO_CODE,
							icon: <PromoCodeIcon />,
						}}
						handleRemoveOverflow={handleRemoveOverflow}
						onAction={changeNavigationView}
						isSectionNav={true}
						cyTestRef="cp-panel-list"
					/>
				</div>

				<div className="action-list">
					<span className="action-list-title">{t('prefrences')}</span>

					<ActionCard
						data={{
							label: t('settings'),
							value: SectionNavigation.CP_SETTINGS,
							icon: <SettingsIcon />,
						}}
						handleRemoveOverflow={handleRemoveOverflow}
						onAction={changeNavigationView}
						cyTestRef="cp-panel-list"
						isSectionNav={true}
					/>

					<ActionCard
						data={{
							label: t('generalSettingsConsents'),
							value: SectionNavigation.CP_MARKETING_CONSENT,
							icon: <MarketingConsentsIcon />,
						}}
						handleRemoveOverflow={handleRemoveOverflow}
						onAction={changeNavigationView}
						cyTestRef="cp-panel-list"
						isSectionNav={true}
					/>
				</div>

				<div className="action-list">
					<span className="action-list-title">{t('help')}</span>
					<ActionCard
						data={{
							label: t('whatsNewInApp'),
							value: APP_URL.whatsNewInApp,
							icon: <StarsIcon />,
						}}
						cyTestRef="cp-panel-list"
						isSectionNav={false}
					/>
					<ActionCard
						data={{
							label: t('helpCenter'),
							externalUrl: EXTERNAL_LINKS.helpCenter,
							icon: <FAQIcon />,
						}}
						cyTestRef="cp-panel-list"
						isSectionNav={false}
					/>

					<ActionCard
						data={{
							label: t('rulesBetSettlement'),
							value: APP_URL.betMarking,
							icon: <RulesIcon />,
						}}
						handleRemoveOverflow={handleRemoveOverflow}
						onAction={changeNavigationView}
						cyTestRef="cp-panel-list"
						isSectionNav={false}
					/>

					<ActionCard
						data={{
							label: t('rgRegulationsAndDocuments'),
							value: SectionNavigation.CP_REGULATIONS,
							icon: <RegulationIcon />,
						}}
						handleRemoveOverflow={handleRemoveOverflow}
						onAction={changeNavigationView}
						cyTestRef="cp-panel-list"
						isSectionNav={true}
					/>

					<ActionCard
						data={{
							label: t('cpChat'),
							value: APP_URL.contact,
							icon: <ChatIcon />,
						}}
						handleRemoveOverflow={handleRemoveOverflow}
						onAction={changeNavigationView}
						cyTestRef="cp-panel-list"
						isSectionNav={false}
					/>
				</div>
			</div>
		</>
	);
};

export default CpActionCards;
